import { React, Divider, Heading } from "mondrian-react";
import { logger } from "utils/logger";

//Style
import "./styles.scss";
import { reportGA4 } from "utils/pushDataLayer";

const Banks = ({localTag}) => {
  return (
    <>
      <Divider />
      <Heading xs className="textTitular">
      Pague com o internet Banking
      </Heading>
      <div>
        <a
          onClick={() => {
            logger({ name: "RedirectNubank" })
            reportGA4({customTitle: `${localTag}:internet_bank_nubank`})
          }}
          target="_blank"
          rel="noreferrer"
          href={"https://nubank.com.br/"}
          className="mdn-Shortcut mdn-Shortcut--secondary card"
          aria-label="Nubank"
        >
          <img
            src="https://mondrian.claro.com.br/brands/app/72px-default/nu-bank.svg"
            alt="Nubank"
            title="Nubank"
            className="cardImage"
          />
          <p className="mdn-Shortcut-text">Nubank</p>
        </a>
        {/* <a
          onClick={() => {
            logger({ name: "RedirectC6bank" })
            reportGA4({customTitle: 'detalhes_de_fatura:internet_bank_c6bank'})
          }}
          target="_blank"
          href={"https://www.c6bank.com.br/"}
          className="mdn-Shortcut mdn-Shortcut--secondary card"
          aria-label="C6 Bank"
        >
          <img
            src={c6bankImage}
            alt="C6 Bank"
            title="C6 Bank"
            className="cardImage"
          />
          <p className="mdn-Shortcut-text">C6 Bank</p>
        </a> */}
        <a
          onClick={() => {
            logger({ name: "RedirectItau" })
            reportGA4({customTitle: `${localTag}:internet_bank_itau`})
          }}
          target="_blank"
          rel="noreferrer"
          href={"https://itau.com.br"}
          className="mdn-Shortcut mdn-Shortcut--secondary card"
          aria-label="Itaú"
        >
          <img
            src="https://mondrian.claro.com.br/brands/app/72px-default/itau.svg"
            alt="Itau"
            title="Itau"
            className="cardImage"
          />
          <p className="mdn-Shortcut-text">Itaú</p>
        </a>
        <a
          onClick={() => {
            logger({ name: "RedirectCaixa" })
            reportGA4({customTitle: `${localTag}:internet_bank_caixa`})
          }}
          target="_blank"
          rel="noreferrer"
          href={"https://www.caixa.gov.br/"}
          className="mdn-Shortcut mdn-Shortcut--secondary card"
          aria-label="Caixa"
        >
          <img
            src="https://mondrian.claro.com.br/brands/app/72px-default/caixa.svg"
            alt="Caixa"
            title="Caixa"
            className="cardImage"
          />
          <p className="mdn-Shortcut-text">Caixa</p>
        </a>
        <a
          onClick={() => {
            logger({ name: "RedirectBradesco" })
            reportGA4({customTitle: `${localTag}:internet_bank_bradesco`})
          }}
          target="_blank"
          rel="noreferrer"
          href={"https://banco.bradesco/"}
          className="mdn-Shortcut mdn-Shortcut--secondary card"
          aria-label="Bradesco"
        >
          <img
            src="https://mondrian.claro.com.br/brands/app/72px-default/bradesco.svg"
            alt="Bradesco"
            title="Bradesco"
            className="cardImage"
          />
          <p className="mdn-Shortcut-text">Bradesco</p>
        </a>
        <a
          onClick={() => {
            logger({ name: "RedirectSantander" })
            reportGA4({customTitle: `${localTag}:internet_bank_santander`})
          }}
          target="_blank"
          rel="noreferrer"
          href={"https://www.santander.com.br/"}
          className="mdn-Shortcut mdn-Shortcut--secondary card"
          aria-label="Santander"
        >
          <img
            src="https://mondrian.claro.com.br/brands/app/72px-default/santander.svg"
            alt="Santander"
            title="Santander"
            className="cardImage"
          />
          <p className="mdn-Shortcut-text">Santander</p>
        </a>
        {/* <a
          onClick={() => {
            logger({ name: "RedirectBrasil" })
            reportGA4({customTitle: 'detalhes_de_fatura:internet_bank_safra'})
          }}
          target="blank"
          href={"https://www.safra.com.br/"}
          className="mdn-Shortcut mdn-Shortcut--secondary card"
          aria-label="Safra"
        >
          <img
            src="/image/safra.svg"
            alt="Safra"
            title="Safra"
            className="cardImage"
          />
          <p className="mdn-Shortcut-text">Safra</p>
        </a> */}
      </div>
    </>
  );
};
export default Banks;
